// @flow

import React from "react";
import moment from "moment";

import { Text } from "@unifize/sarah";
import * as colors from "src/styles/constants/colors";

type Props = {
  timestamp: string,
};

const Datestamp = ({ timestamp }: Props) => {
  return (
    <Text variant="pill" color={colors.grey21Alpha}>
      {moment(timestamp).format("MMM Do")}
    </Text>
  );
};

export default Datestamp;
